export default __webpack_public_path__ + "fonts/LeituraNews-Roman1.ttf";